import { ILayerProps } from '@/version-types';
import { IDrawInfo } from '../types';

export const updateExtendState = (layer: ILayerProps, newPathInfos: IDrawInfo[]) => {
    layer.__extendedState = {
        ...layer.__extendedState,
        pathInfos: newPathInfos,
    };

    return layer;
};

export const getExtendState = (layer: ILayerProps) => {
    return (layer.__extendedState?.pathInfos as IDrawInfo[]) || [];
};
